import React from "react";
import TagChip from "@/components/common/TagChip";
import { CouponIcon } from "@/components/icons";

export type DiscountChipProps = {
  label: string;
  icon?: React.ReactNode;
  size?: "default" | "compact";
  /**
   * Informational catalog badges stay `false` (no hover lift / pointer).
   * Interactive offer chips keep existing click handlers on the parent.
   */
  interactive?: boolean;
  disabled?: boolean;
};

/**
 * Platform-semantic discount / offer pill. Rich Premium Gold paint only.
 * Does not read tenant branding, Theme Color, or CTA tokens.
 */
export function DiscountChip({
  label,
  icon,
  size = "default",
  interactive = false,
  disabled = false,
}: DiscountChipProps) {
  return (
    <TagChip
      variant="promo"
      label={label}
      size={size}
      interactive={interactive}
      disabled={disabled}
      icon={icon ?? <CouponIcon aria-hidden />}
    />
  );
}

export default DiscountChip;
